<template>
	<div class="editor-container">
		<codeEditor
			:value="code"
			lang="json"
			theme="monokai"
			:options="options"
			@init="editorInit($event)">
		</codeEditor>
	</div>
</template>

<script>
export default {
	components: {
		codeEditor: require('vue2-ace-editor')
	},
	props: [ 'code', 'fold_level', 'max_lines' ],
	data () {
		return {
			editor: null,
			options: {
				readOnly: true,
				maxLines: this.max_lines || 30,
				minLines: 1,
				fontSize: '14px',
				printMargin: false,
				wrap: true,
				autoScrollEditorIntoView: false
			}
		}
	},
	methods: {
		editorInit: function (editor) {
			this.editor = editor
			require('brace/mode/json')
			require('brace/snippets/json')
			require('brace/theme/monokai')
			require('brace/ext/language_tools')
			require('brace/ext/searchbox')
			require('brace/ext/beautify')
			this.$nextTick(() => {
				if (this.fold_level === undefined) {
					editor.session.unfold()
					return
				}
				editor.session.foldAll()
				let folds
				for (var i = 0; i < this.fold_level; i++) {
					folds = editor.session.getAllFolds()
					if (folds.length === 0) break
					editor.session.expandFolds(folds)
				}
			})
		}
	}
}
</script>

<style scoped lang="stylus">
.ace_editor.ace-monokai.ace_dark
	background-color: var(--v-background-darken1) !important
	>>>.ace_gutter
		background-color: var(--v-background-darken2) !important
		z-index: 3
		>>>.ace_gutter-cell
			padding-right: 20px !important
		.ace_fold-widget
			transform: scale(1.5) !important
	>>>.ace_selected-word
		border: 1px solid #ffe800
	>>>.ace_active-line
	>>>.ace_gutter-active-line
		background-color: inherit

>>>.ace_search
>>>.ace_search_field
>>>.ace_searchbtn
	border-color: var(--v-background-lighten3)
	color: white

>>>.ace_search
>>>.ace_search_options > *
	color: white
	background-color: var(--v-background-base)

>>>.ace_searchbtn_close
	background-color: white

>>>.ace_search_form
>>>.ace_replace_form
	*
		background-color: var(--v-background-darken1)

::-webkit-scrollbar
::-webkit-scrollbar-track-piece
	background-color: var(--v-background-darken1) !important

</style>



// WEBPACK FOOTER //
// src/components/ace_json_viewer.vue